// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__1mmjz","bottom":"Layout_bottom__1Arll","left":"Layout_left__4PM13","right":"Layout_right__3q-U6"};